import { decode } from 'html-entities';

import { uri } from 'utils';

import { HEADER_SEARCH_QUERY_PARAMETER_ID } from '../../search/constants';

/**
 * @param {string} url
 * @returns {string}
 */
const getSearchValueFromURL = url => {
    const urlParameter = uri.getParams(url)[HEADER_SEARCH_QUERY_PARAMETER_ID];

    if (!urlParameter) {
        return '';
    }

    const sanitized = decode(urlParameter);

    return sanitized;
};

export default getSearchValueFromURL;
